import NavigationBar from "../../components/NavigationBar";
import styles from "../styles/RegisterHeader.module.scss";

export default function RegisterHeader() {
  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <NavigationBar></NavigationBar>
      </div>
    </div>
  );
}
